export enum EnaioErrorCode {
    unknown = 0,
    generalError = 1,
    generalTechnicalError = 2,
    recoverableDatabaseError = 3,
    possibleOutOfMemory = 4,
    archiveNotFound = 5,
    objectTypeNotFound = 6,
    folderNotFound = 7,
    objectTypeDoesNotAllowDocuments = 8,
    folderNotSpecified = 9,
    maximumChildCountExceeded = 10,
    insertLocationNeeded = 11,
    fieldMaxLengthExceeded = 12,
    fieldIsMandatory = 13,
    mainTypeDocumentMismatch = 14,
    documentMoveNeedsSourceLocation = 15,
    readOnlyFieldCannotBeWritten = 16,
    readOnlyFieldAfterInitializationCannotBeWritten = 17,
    objectHasNoDocument = 18,
    objectCanNotHaveDocument = 19,
    documentWasDeletedCanBeRecovered = 20,
    couldNotEstablishConnection = 21,
    couldNotEstablishConnectionTimeout = 22,
    clientServerVersionMismatch = 23,
    invalidUserName = 24,
    invalidPassword = 25,
    accountLocked = 26,
    couldNotDeleteObjectIsConnectedToWorkflow = 27,
    invalidFullTextConfig = 28,
    noPasswordProvided = 29,
    fieldNotFound = 30,
    tableColumnNotFound = 31,
    invalidRightGroupAddonValue = 32,
    couldNotGetIndexDataHistory = 33,
    switchContextFailedUnknownUser = 34,
    canNotUpdateDocumentAlreadyArchived = 35,
    workflowParamsRecordMemberMissing = 36,
    noCascadingDeletion = 37,
    jobQueueOverload = 38,
    workItemIdInvalid = 39,
    userMustNotPersonalizeWorkItem = 40,
    clientTypeDoesNotSupportWorkflow = 41,
    couldNotStartWfNoActiveModel = 42,
    databaseError = 43,
    genericDatabaseSqlError = 44,
    genericDatabaseError = 45,
    connectionProblemTemporary = 46,
    linkedCatalogueCorrupt = 47,
    linkedCatalogueCorruptArchiveNotFound = 48,
    linkedCatalogueCorruptObjectTypeNotFound = 49,
    linkedCatalogueCorruptFieldNotFound = 50,
    invalidMainTypeForTypelessDocument = 51,
    registerDoesNotExist = 52,
    registerDoesNotExistObjectDoesNotExist = 53,
    registerDoesNotExistObjectIsNotARegister = 54,
    catalogueHasNoEntries = 55,
    catalogueInvalidValue = 56,
    couldNotLoadIcon = 57,
    userMustNotStartProcess = 58,
    enaioUniqueKeyError = 59,
    emptyImportDocument = 60,
    invalidDateFormat = 61,
    invalidBoolFormat = 62,
    invalidNumberFormat = 63,
    invalidDecimalFormat = 64,
    invalidOperator = 65,
    invalidWfUserGuid = 66,
    invalidWfFamilyId = 67,
    invalidWfVariable = 68,
    invalidWfVariableValue = 69,
    invalidWfVariableDataType = 70,
    invalidWorkItemId = 71,
    internalScriptError = 72,
    objectIdNotFound = 73,
    userNotFound = 74,
    missingOrganisationId = 75,
    missingParameter = 76,
    getDocStatisticsNotAllowed = 77,
    userRightMissing = 78,
    remarkObjectAlreadyLinked = 79,
    triedToLinkToDocumentAndAppendDocument = 80,
    userMustNotForward = 81,
    canNotForward = 82,
    userMustNotPersonalizeWorkItemBecauseOfInvalidStatus = 83,
    scriptParsingError = 84,
    scriptExecutionError = 85,
    processCouldNotBeExamined = 86,
    processCouldNotBeSuspended = 87,
    processCouldNotBeSuspendedDoesNotExist = 88,
    processCouldNotBeSuspendedIsFinished = 89,
    processCouldNotBeSuspendedAlreadySuspended = 90,
    processCouldNotBeResumedAlreadyRunning = 91,
    jobParameterWrongDataType = 92,
    jobParameterWrongValue = 93,
    renBatTemporary = 94,
    renBatRestartDocumentViewer = 95,
    couldNotConvertDocument = 96,
    convertDocumentTimeout = 97,
    archivedDocumentNotFound = 98,
    couldNotGetJobResult = 99,
    missingSysRole = 100,
    couldNotAccessFile = 101,
    cannotDeleteFromWfTray = 102,
    lostConnection = 103,
    enaioServerIsMaybeRestarting = 104,
    internalEnaioErrorReconnect = 105,
    internalDatabaseIndexCouldNotBeObtained = 106,
    internalDatabaseCouldNotObtainLock = 107,
    internalEnaioErrorRestartApp = 108,
    internalJobInvalidPointer = 109,
    invalidXmlInternalRetry = 110,
    invalidSessionProperty = 111,
    comException = 112,
    comExceptionDisp = 113,
    enaioComClassNotRegistered = 114,
    enaioClientNotInstalled = 115,
    unspecifiedRestartEnaio = 116
}
export namespace EnaioErrorCode{
    export function getName(value: EnaioErrorCode): string {
        switch (value) {
            case EnaioErrorCode.unknown:
                return "unknown";
            case EnaioErrorCode.generalError:
                return "generalError";
            case EnaioErrorCode.generalTechnicalError:
                return "generalTechnicalError";
            case EnaioErrorCode.recoverableDatabaseError:
                return "recoverableDatabaseError";
            case EnaioErrorCode.possibleOutOfMemory:
                return "possibleOutOfMemory";
            case EnaioErrorCode.archiveNotFound:
                return "archiveNotFound";
            case EnaioErrorCode.objectTypeNotFound:
                return "objectTypeNotFound";
            case EnaioErrorCode.folderNotFound:
                return "folderNotFound";
            case EnaioErrorCode.objectTypeDoesNotAllowDocuments:
                return "objectTypeDoesNotAllowDocuments";
            case EnaioErrorCode.folderNotSpecified:
                return "folderNotSpecified";
            case EnaioErrorCode.maximumChildCountExceeded:
                return "maximumChildCountExceeded";
            case EnaioErrorCode.insertLocationNeeded:
                return "insertLocationNeeded";
            case EnaioErrorCode.fieldMaxLengthExceeded:
                return "fieldMaxLengthExceeded";
            case EnaioErrorCode.fieldIsMandatory:
                return "fieldIsMandatory";
            case EnaioErrorCode.mainTypeDocumentMismatch:
                return "mainTypeDocumentMismatch";
            case EnaioErrorCode.documentMoveNeedsSourceLocation:
                return "documentMoveNeedsSourceLocation";
            case EnaioErrorCode.readOnlyFieldCannotBeWritten:
                return "readOnlyFieldCannotBeWritten";
            case EnaioErrorCode.readOnlyFieldAfterInitializationCannotBeWritten:
                return "readOnlyFieldAfterInitializationCannotBeWritten";
            case EnaioErrorCode.objectHasNoDocument:
                return "objectHasNoDocument";
            case EnaioErrorCode.objectCanNotHaveDocument:
                return "objectCanNotHaveDocument";
            case EnaioErrorCode.documentWasDeletedCanBeRecovered:
                return "documentWasDeletedCanBeRecovered";
            case EnaioErrorCode.couldNotEstablishConnection:
                return "couldNotEstablishConnection";
            case EnaioErrorCode.couldNotEstablishConnectionTimeout:
                return "couldNotEstablishConnectionTimeout";
            case EnaioErrorCode.clientServerVersionMismatch:
                return "clientServerVersionMismatch";
            case EnaioErrorCode.invalidUserName:
                return "invalidUserName";
            case EnaioErrorCode.invalidPassword:
                return "invalidPassword";
            case EnaioErrorCode.accountLocked:
                return "accountLocked";
            case EnaioErrorCode.couldNotDeleteObjectIsConnectedToWorkflow:
                return "couldNotDeleteObjectIsConnectedToWorkflow";
            case EnaioErrorCode.invalidFullTextConfig:
                return "invalidFullTextConfig";
            case EnaioErrorCode.noPasswordProvided:
                return "noPasswordProvided";
            case EnaioErrorCode.fieldNotFound:
                return "fieldNotFound";
            case EnaioErrorCode.tableColumnNotFound:
                return "tableColumnNotFound";
            case EnaioErrorCode.invalidRightGroupAddonValue:
                return "invalidRightGroupAddonValue";
            case EnaioErrorCode.couldNotGetIndexDataHistory:
                return "couldNotGetIndexDataHistory";
            case EnaioErrorCode.switchContextFailedUnknownUser:
                return "switchContextFailedUnknownUser";
            case EnaioErrorCode.canNotUpdateDocumentAlreadyArchived:
                return "canNotUpdateDocumentAlreadyArchived";
            case EnaioErrorCode.workflowParamsRecordMemberMissing:
                return "workflowParamsRecordMemberMissing";
            case EnaioErrorCode.noCascadingDeletion:
                return "noCascadingDeletion";
            case EnaioErrorCode.jobQueueOverload:
                return "jobQueueOverload";
            case EnaioErrorCode.workItemIdInvalid:
                return "workItemIdInvalid";
            case EnaioErrorCode.userMustNotPersonalizeWorkItem:
                return "userMustNotPersonalizeWorkItem";
            case EnaioErrorCode.clientTypeDoesNotSupportWorkflow:
                return "clientTypeDoesNotSupportWorkflow";
            case EnaioErrorCode.couldNotStartWfNoActiveModel:
                return "couldNotStartWfNoActiveModel";
            case EnaioErrorCode.databaseError:
                return "databaseError";
            case EnaioErrorCode.genericDatabaseSqlError:
                return "genericDatabaseSqlError";
            case EnaioErrorCode.genericDatabaseError:
                return "genericDatabaseError";
            case EnaioErrorCode.connectionProblemTemporary:
                return "connectionProblemTemporary";
            case EnaioErrorCode.linkedCatalogueCorrupt:
                return "linkedCatalogueCorrupt";
            case EnaioErrorCode.linkedCatalogueCorruptArchiveNotFound:
                return "linkedCatalogueCorruptArchiveNotFound";
            case EnaioErrorCode.linkedCatalogueCorruptObjectTypeNotFound:
                return "linkedCatalogueCorruptObjectTypeNotFound";
            case EnaioErrorCode.linkedCatalogueCorruptFieldNotFound:
                return "linkedCatalogueCorruptFieldNotFound";
            case EnaioErrorCode.invalidMainTypeForTypelessDocument:
                return "invalidMainTypeForTypelessDocument";
            case EnaioErrorCode.registerDoesNotExist:
                return "registerDoesNotExist";
            case EnaioErrorCode.registerDoesNotExistObjectDoesNotExist:
                return "registerDoesNotExistObjectDoesNotExist";
            case EnaioErrorCode.registerDoesNotExistObjectIsNotARegister:
                return "registerDoesNotExistObjectIsNotARegister";
            case EnaioErrorCode.catalogueHasNoEntries:
                return "catalogueHasNoEntries";
            case EnaioErrorCode.catalogueInvalidValue:
                return "catalogueInvalidValue";
            case EnaioErrorCode.couldNotLoadIcon:
                return "couldNotLoadIcon";
            case EnaioErrorCode.userMustNotStartProcess:
                return "userMustNotStartProcess";
            case EnaioErrorCode.enaioUniqueKeyError:
                return "enaioUniqueKeyError";
            case EnaioErrorCode.emptyImportDocument:
                return "emptyImportDocument";
            case EnaioErrorCode.invalidDateFormat:
                return "invalidDateFormat";
            case EnaioErrorCode.invalidBoolFormat:
                return "invalidBoolFormat";
            case EnaioErrorCode.invalidNumberFormat:
                return "invalidNumberFormat";
            case EnaioErrorCode.invalidDecimalFormat:
                return "invalidDecimalFormat";
            case EnaioErrorCode.invalidOperator:
                return "invalidOperator";
            case EnaioErrorCode.invalidWfUserGuid:
                return "invalidWfUserGuid";
            case EnaioErrorCode.invalidWfFamilyId:
                return "invalidWfFamilyId";
            case EnaioErrorCode.invalidWfVariable:
                return "invalidWfVariable";
            case EnaioErrorCode.invalidWfVariableValue:
                return "invalidWfVariableValue";
            case EnaioErrorCode.invalidWfVariableDataType:
                return "invalidWfVariableDataType";
            case EnaioErrorCode.invalidWorkItemId:
                return "invalidWorkItemId";
            case EnaioErrorCode.internalScriptError:
                return "internalScriptError";
            case EnaioErrorCode.objectIdNotFound:
                return "objectIdNotFound";
            case EnaioErrorCode.userNotFound:
                return "userNotFound";
            case EnaioErrorCode.missingOrganisationId:
                return "missingOrganisationId";
            case EnaioErrorCode.missingParameter:
                return "missingParameter";
            case EnaioErrorCode.getDocStatisticsNotAllowed:
                return "getDocStatisticsNotAllowed";
            case EnaioErrorCode.userRightMissing:
                return "userRightMissing";
            case EnaioErrorCode.remarkObjectAlreadyLinked:
                return "remarkObjectAlreadyLinked";
            case EnaioErrorCode.triedToLinkToDocumentAndAppendDocument:
                return "triedToLinkToDocumentAndAppendDocument";
            case EnaioErrorCode.userMustNotForward:
                return "userMustNotForward";
            case EnaioErrorCode.canNotForward:
                return "canNotForward";
            case EnaioErrorCode.userMustNotPersonalizeWorkItemBecauseOfInvalidStatus:
                return "userMustNotPersonalizeWorkItemBecauseOfInvalidStatus";
            case EnaioErrorCode.scriptParsingError:
                return "scriptParsingError";
            case EnaioErrorCode.scriptExecutionError:
                return "scriptExecutionError";
            case EnaioErrorCode.processCouldNotBeExamined:
                return "processCouldNotBeExamined";
            case EnaioErrorCode.processCouldNotBeSuspended:
                return "processCouldNotBeSuspended";
            case EnaioErrorCode.processCouldNotBeSuspendedDoesNotExist:
                return "processCouldNotBeSuspendedDoesNotExist";
            case EnaioErrorCode.processCouldNotBeSuspendedIsFinished:
                return "processCouldNotBeSuspendedIsFinished";
            case EnaioErrorCode.processCouldNotBeSuspendedAlreadySuspended:
                return "processCouldNotBeSuspendedAlreadySuspended";
            case EnaioErrorCode.processCouldNotBeResumedAlreadyRunning:
                return "processCouldNotBeResumedAlreadyRunning";
            case EnaioErrorCode.jobParameterWrongDataType:
                return "jobParameterWrongDataType";
            case EnaioErrorCode.jobParameterWrongValue:
                return "jobParameterWrongValue";
            case EnaioErrorCode.renBatTemporary:
                return "renBatTemporary";
            case EnaioErrorCode.renBatRestartDocumentViewer:
                return "renBatRestartDocumentViewer";
            case EnaioErrorCode.couldNotConvertDocument:
                return "couldNotConvertDocument";
            case EnaioErrorCode.convertDocumentTimeout:
                return "convertDocumentTimeout";
            case EnaioErrorCode.archivedDocumentNotFound:
                return "archivedDocumentNotFound";
            case EnaioErrorCode.couldNotGetJobResult:
                return "couldNotGetJobResult";
            case EnaioErrorCode.missingSysRole:
                return "missingSysRole";
            case EnaioErrorCode.couldNotAccessFile:
                return "couldNotAccessFile";
            case EnaioErrorCode.cannotDeleteFromWfTray:
                return "cannotDeleteFromWfTray";
            case EnaioErrorCode.lostConnection:
                return "lostConnection";
            case EnaioErrorCode.enaioServerIsMaybeRestarting:
                return "enaioServerIsMaybeRestarting";
            case EnaioErrorCode.internalEnaioErrorReconnect:
                return "internalEnaioErrorReconnect";
            case EnaioErrorCode.internalDatabaseIndexCouldNotBeObtained:
                return "internalDatabaseIndexCouldNotBeObtained";
            case EnaioErrorCode.internalDatabaseCouldNotObtainLock:
                return "internalDatabaseCouldNotObtainLock";
            case EnaioErrorCode.internalEnaioErrorRestartApp:
                return "internalEnaioErrorRestartApp";
            case EnaioErrorCode.internalJobInvalidPointer:
                return "internalJobInvalidPointer";
            case EnaioErrorCode.invalidXmlInternalRetry:
                return "invalidXmlInternalRetry";
            case EnaioErrorCode.invalidSessionProperty:
                return "invalidSessionProperty";
            case EnaioErrorCode.comException:
                return "comException";
            case EnaioErrorCode.comExceptionDisp:
                return "comExceptionDisp";
            case EnaioErrorCode.enaioComClassNotRegistered:
                return "enaioComClassNotRegistered";
            case EnaioErrorCode.enaioClientNotInstalled:
                return "enaioClientNotInstalled";
            case EnaioErrorCode.unspecifiedRestartEnaio:
                return "unspecifiedRestartEnaio";
        }
    }
}
